import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import Strings from '../../../Strings';
import { shippingActions } from '../../Shipping/actions';
import { ShippingTabs } from '../../Shipping';
import { pendingReviewCountRequest } from '../../Shipping/reviewQueueRequest';

function OrdersPendingReview(props) {
  const { getData, onClick, refreshTimestamp, orgIds } = props;
  const [data, setData] = React.useState('-');

  React.useEffect(() => {
    // The count is per org selection, so a slower response for a previous
    // selection must not overwrite the current one.
    let current = true;
    getData(pendingReviewCountRequest(orgIds)).then(resp => {
      if (current && resp?.response?.pagination?.totalRecords !== undefined) {
        setData(resp.response.pagination.totalRecords);
      }
    });
    return () => { current = false; };
  }, [refreshTimestamp, orgIds]);

  return (
    <div className="boxWithVl-box">
      <div className="boxWithVl-valueBox black">{data}</div>
      <div
        onClick={() => onClick(`${ShippingTabs.SHIPPING_ORDERS.url}?status=Pending Review`)}
        className="boxWithVl-labelBox clickable"
      >
        {Strings.widgets.ordersPendingReview}
      </div>
    </div>
  )
}

OrdersPendingReview.widgetId = 'OrdersPendingReviewWidget';

OrdersPendingReview.propTypes = {
  getData: PropTypes.func,
  onClick: PropTypes.func,
  orgIds: PropTypes.arrayOf(PropTypes.string),
  refreshTimestamp: PropTypes.number,
};

const mapStateToProps = state => {
  return {
    orgIds: state.entities?.orgFilter?.orgIds,
  };
};

const mapDispatchToProps = dispatch => ({
  getData: params => dispatch(shippingActions.getReviewQueue(params)),
  onClick: path => dispatch(push(path)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrdersPendingReview);
